<script setup lang="ts">
import type { Service } from '~/components/services/exercise';

defineProps<{ title: string; services: Service[] }>();
</script>

<template>
  <div class="gap-r8 flex flex-col">
    <AppTextStroke
      as="h3"
      stroke="var(--color-client-white)"
      stroke-width="3px"
      fill="var(--color-client-black)"
      class="font-bold"
    >
      <AppText size="3xl">{{ title }}</AppText>
    </AppTextStroke>
    <div class="gap-r5 grid grid-cols-3">
      <AppLink
        v-for="(service, i) in services"
        :key="i"
        type="custom"
        :to="service.url"
        :opts="{}"
        class="group/exercise-card relative aspect-390/198 cursor-pointer overflow-hidden rounded-2xl select-none"
      >
        <img
          :src="service.image"
          :alt="service.title"
          class="size-full object-cover transition-transform duration-300 ease-in-out lg:aspect-3/1 lg:group-hover/exercise-card:scale-105 lg:group-active/exercise-card:scale-110"
        />
        <div
          class="from-client-black/80 absolute inset-0 size-full bg-linear-to-t to-transparent"
        ></div>

        <div class="top-r2 right-r2 absolute size-12">
          <div
            class="bg-client-orange size-full rounded-full transition-transform duration-300 group-active/exercise-card:scale-100 lg:group-hover/exercise-card:scale-120"
          ></div>
          <SVGArrowSharp class="absolute inset-1/2 size-1/2 -translate-1/2" />
        </div>

        <div class="px-r4 py-r8 gap-r2 absolute bottom-0 flex flex-col">
          <AppIcon
            v-if="service.icon"
            :name="service.icon"
            size="custom"
            class="size-r16 2xl:size-r18 drop-shadow-xl drop-shadow-black"
          />
          <AppHeading tag="h4">
            {{ service.title }}
          </AppHeading>
        </div>
      </AppLink>
    </div>
  </div>
</template>
